@if (messageInputController().hasError('maxlength')) {
  <div class="error-wrapper">
    <orbit-message
      [message]="
        'SHARED.CONVERSATION_FOOTER.ERROR_MESSAGE'
          | translate
            : {
                maxChars: messageInputController().errors?.['maxlength']?.requiredLength,
                yourChars: messageInputController().errors?.['maxlength']?.actualLength,
              }
      "
      [title]="'SHARED.CONVERSATION_FOOTER.TITLE' | translate"
      [severity]="'error'" />
  </div>
}

@if (isConversationLocked()) {
  <!-- CONVERSATIOM LOCKED -->
  <div class="info-message" data-testid="conversation-locked-message">
    <span class="message-text">
      {{ conversationLockNote() | translate }}
    </span>
    <orbit-button
      [icon]="unlockIcon"
      [size]="'large'"
      (click)="unlockAction.emit(conversationId())" />
  </div>
} @else if (isConversationArchived()) {
  <!-- CONVERSATION ARCHIVED -->
  <div class="info-message" data-testid="conversation-archived-message">
    <span class="message-text">
      {{ 'SHARED.CONVERSATION_FOOTER.ARCHIVED_NOTE' | translate }}
    </span>
  </div>
} @else if (userId() && noUsers()) {
  <!-- NO USERS -->
  <div class="info-message" data-testid="conversation-no-users-message">
    <span class="message-text">
      {{ 'SHARED.PARTICIPANT_LIST.NO_USERS' | translate }}
    </span>
    <orbit-button
      [icon]="joinIcon"
      [size]="'small'"
      [testId]="'btn-conversation-footer-join'"
      (click)="joinConversation.emit()"
      [label]="'SHARED.PARTICIPANT_LIST.JOIN' | translate" />
  </div>
} @else if (userId() && userIsNotParticipant()) {
  <!-- LOGGED IN USER IS NOT A PARTICIPANT -->
  <div class="info-message" data-testid="conversation-not-participant-message">
    <span class="message-text">
      {{ 'SHARED.PARTICIPANT_LIST.ADD_YOURSELF' | translate }}
    </span>
    <orbit-button
      [icon]="joinIcon"
      [size]="'small'"
      [testId]="'btn-conversation-footer-join'"
      (click)="joinConversation.emit()"
      [label]="'SHARED.PARTICIPANT_LIST.JOIN' | translate" />
  </div>
} @else {
  @if (conversationId()) {
    <div class="input-bar">
      <orbit-button
        [testId]="'btn-show-addon-bar'"
        [styleClass]="addonButtonStyle()"
        rounded
        [icon]="addonButtonIcon()"
        (onClick)="toggleFooterAddon()" />
      <orbit-input
        inputType="textarea"
        class="input"
        inputId="message-input"
        rounded
        [testId]="'conversation-footer-input'"
        [addonRight]="{
          button: true,
          icon: arrowUpIcon,
          disabled: messageInputController().invalid || loading(),
        }"
        [preventTyping]="loading()"
        [loading]="loading()"
        [placeholder]="'SHARED.CONVERSATION_FOOTER.PLACEHOLDER' | translate"
        [controller]="messageInputController()"
        (addonButtonClicked)="sendMessageHandler($event)"
        (enterPressed)="
          !messageInputController().invalid && !loading() ? sendMessageHandler($event) : null
        "
        (deleteAttachmentEvent)="handleDeleteAttachment($event)"
        [inputSourceId]="nextMessageSourceId()"
        [(files)]="files"
        (isTyping)="isTyping.emit($event)" />
    </div>
  }
}
@if (addonBarVisible()) {
  <shared-footer-addon
    [senderType]="senderType()"
    [templates]="templates()"
    (buttonClick)="handleAddonClick($event)"
    [(files)]="files"
    [deletedAttachment]="deletedAttachment()" />
}
